<template>
<div class="legal-page">
  <el-menu :title="true" align="left" center>
    <el-menu-item title="Personuppgiftspolicy">
      <personal-policy />
    </el-menu-item>
    <el-menu-item title="Allmänna Villkor">
      <terms-and-conditions />
    </el-menu-item>
  </el-menu>

  <info-footer />
</div>
</template>
<script>
import PersonalPolicy from '@/components/legal/PersonalPolicy.vue'
import TermsAndConditions from '@/components/legal/TermsAndConditions.vue'
import InfoFooter from '@/components/landingPage/InfoFooter.vue'

export default {
  name: 'LegalPage',
  components: { PersonalPolicy, TermsAndConditions, InfoFooter }
}
</script>
<style scoped lang="less">
  @import '../style/variables.less';

  .legal-page {
    position: relative;
  }

  .legal-wrapper {
    position: relative;
    left: auto;
    margin: auto;
    display: flex;
    width: 100%;
    max-width: @width-max;
    flex-direction: column;
  }
</style>
